export const getDomainName = () => {
    //figure out how to parse out the base domain
    let urlDomainName = window.location.hostname; //This is where I'm gonna find domain name from window.location.href
    let urlArr = urlDomainName.split('.')
    let baseArr = urlArr.splice(3)
    let baseString = baseArr.join('.')
    return baseString
}
